import Component from '../abstracts/Component';

export default class ShortcutPromoComponent extends Component {

  get SELECTORS() {
    return {
      shortcutPromo: '[data-componentpb="ShortcutPromoComponent"]',
      slide: '[data-slide]',
      anchor: 'a'
    };
  }

  get CSS_CUSTOMVARS() {
    return {
      jsHeightShortcutPromo: '--js-shortcut-promo-height'
    };
  }

  get CSS_CLASSNAMES() {
    return {
      selected: 'selected',
      shortcutPromoIsSticky: 'shortcut-promo-is-sticky'
    };
  }

  constructor(elem) {
    super(elem);
    this.shortcutPromo = document.querySelector(this.SELECTORS.shortcutPromo);
    this.shortcutPromoHeight = this.shortcutPromo ? this.shortcutPromo.offsetHeight : 0;
  }

  readDOM() {
    return {
      slides: [...this.shortcutPromo.querySelectorAll(this.SELECTORS.slide)],
    };
  }

  bindEvents() {
    this.dom.slides.forEach((item, index, allSlidesArr) => {
      item.querySelector(this.SELECTORS.anchor).addEventListener('click', () => {
        //exit when click on first shortcut & was already selected
        if (item.classList.contains(this.CSS_CLASSNAMES.selected)) {
          return;
        } else {
          this.dom.slides.forEach(otherEl => {
            if (otherEl.id === item.id) {
              otherEl.classList.toggle(this.CSS_CLASSNAMES.selected, true);
            } else {
              //unselect other items
              otherEl.classList.toggle(this.CSS_CLASSNAMES.selected, false);
            }
          });
        }
      });
    });

    window.addEventListener('scroll', () => {
      let pageY = this.shortcutPromo !== null ? this.shortcutPromo.getBoundingClientRect().top : 0;
      const activeSticky = this.shortcutPromo != null && window.scrollY > pageY;

      this.shortcutPromo.classList.toggle(this.CSS_CLASSNAMES.shortcutPromoIsSticky, activeSticky);
    });

    window.addEventListener('hashchange', () => {
      this.checkPromoSelected();
    });
  }

  checkPromoSelected() {
    const hashParams = window.location.hash;
    if (!hashParams) return;
    this.dom.slides.forEach(item => {
      let isCurrent = false;
      if (hashParams == item.firstElementChild.hash) {
        isCurrent = true;
      }
      item.classList.toggle(this.CSS_CLASSNAMES.selected, isCurrent);
    });
  }

  setCustomVar() {
    const root = document.documentElement;
    root.style.setProperty(this.CSS_CUSTOMVARS.jsHeightShortcutPromo, `${this.shortcutPromoHeight}px`);
  }

  listenResize() {
    window.addEventListener('resize', () => {
      this.shortcutPromoHeight = this.shortcutPromo ? this.shortcutPromo.offsetHeight : 0;
      this.setCustomVar();
    });
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.setCustomVar();
    this.listenResize();
    this.checkPromoSelected();
    this.bindEvents();
  }
}
